"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var LinkInputBox_1 = __importDefault(require("Project/QwilrEditor/Widgets/LinkInputBox"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var mobx_1 = require("mobx");
var LinkInput = (function (_super) {
    __extends(LinkInput, _super);
    function LinkInput(props) {
        var _this = _super.call(this, props) || this;
        _this.textInput = null;
        _this.allowError = false;
        _this.toggleAllowError = function (show) {
            _this.allowError = show;
        };
        _this.handleBlur = function (ev, href) {
            _this.toggleAllowError(true);
            _this.props.onInputBlur(ev, href);
        };
        _this.handleChange = function () {
            if (_this.allowError) {
                _this.toggleAllowError(false);
            }
        };
        _this.blurInput = function () {
            if (_this.textInput) {
                _this.textInput.blur();
            }
        };
        _this.getTextInputElement = function (elem) {
            _this.textInput = elem;
        };
        return _this;
    }
    LinkInput.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.focus && this.textInput) {
            setTimeout(function () {
                if (_this.textInput) {
                    _this.textInput.focus();
                }
            });
        }
        if (this.props.hasError) {
            this.toggleAllowError(true);
        }
    };
    LinkInput.prototype.render = function () {
        return (react_1.default.createElement("span", { className: "editor-toolbar center-aligned qwilr-font" },
            react_1.default.createElement(kaleidoscope_1.Tooltip, { content: "Link is not a valid URL", size: kaleidoscope_1.TooltipSize.Large, show: this.allowError && this.props.hasError },
                react_1.default.createElement(LinkInputBox_1.default, { href: this.props.href, onInputClick: this.props.onInputClick, placeholder: this.props.placeholder, onInputBlur: this.handleBlur, onInputFocus: this.props.onInputFocus, blurInput: this.blurInput, getTextInputElement: this.getTextInputElement, onChange: this.handleChange })),
            this.renderTick(),
            this.renderRemoveLink(),
            this.renderContextualStyle()));
    };
    LinkInput.prototype.renderContextualStyle = function () {
        if (this.props.showStyleButton && this.props.toggleShowStyle) {
            return (react_1.default.createElement("span", { className: (0, classnames_1.default)([
                    "editor-toolbar__button",
                    { "editor-toolbar__button--active": this.props.showContextualStyle },
                ]), onMouseUp: this.props.toggleShowStyle, onMouseDown: this.preventDefault },
                react_1.default.createElement(icons_1.Styles, null)));
        }
    };
    LinkInput.prototype.renderTick = function () {
        var className = "editor-toolbar__button ";
        var mouseUpAction = this.blurInput;
        return (react_1.default.createElement("span", { className: className, onMouseUp: mouseUpAction, onMouseDown: this.preventDefault },
            react_1.default.createElement(icons_1.Tick, null)));
    };
    LinkInput.prototype.renderRemoveLink = function () {
        return (react_1.default.createElement("span", { className: "editor-toolbar__button", onMouseUp: this.props.removeLink },
            react_1.default.createElement(icons_1.Unlink, null)));
    };
    LinkInput.prototype.preventDefault = function (event) {
        event.preventDefault();
    };
    LinkInput.defaultProps = {
        placeholder: "Paste your link here",
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], LinkInput.prototype, "allowError", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], LinkInput.prototype, "toggleAllowError", void 0);
    LinkInput = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], LinkInput);
    return LinkInput;
}(react_1.default.Component));
exports.default = LinkInput;
